/**
 * FAQ content data - extracted for maintainability
 */

export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: "How long does it take to receive my letter?",
    answer:
      "Most letters arrive in your inbox within a few minutes. Occasionally, during busy times or for particularly complex destinations, it may take up to 24 hours. Eunice likes to take her time with the details.",
  },
  {
    question: "Are the letters really written by AI?",
    answer:
      "Yes, Eunice is an AI persona powered by advanced language models. But don't let that fool you—each letter is crafted with care, drawing on vast knowledge of travel, culture, and human connection. The stories feel real because they're inspired by countless real experiences.",
  },
  {
    question: "Can I trust the recommendations in my letter?",
    answer:
      "Eunice's letters are meant to inspire, not replace your own research. While we strive for accuracy, always verify specific details like opening hours, prices, and availability before your trip. Think of it as a starting point for your adventure, not a definitive guide.",
  },
  {
    question: "What if I'm not happy with my letter?",
    answer:
      "Since letters are digital goods delivered immediately, we can't offer refunds. However, if something seems genuinely wrong with your letter, reach out to letters@eunice.world and we'll make it right.",
  },
  {
    question: "Can I request a letter for any city in the world?",
    answer:
      "Eunice has wandered far and wide! She can write about most cities and towns around the globe. Some very small or remote places might have less detailed letters, but she'll always share what wisdom she can.",
  },
  {
    question: "What's included in a letter?",
    answer:
      "Each letter includes Eunice's personal stories about your destination, hidden gems she's discovered, cultural insights, food recommendations, and the kind of travel wisdom that only comes from decades of wandering. It's typically 800-1200 words of heartfelt advice.",
  },
];

/**
 * Generate FAQ schema for SEO (FAQPage structured data)
 */
export function generateFAQSchema(items: FAQItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
}
